<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 承包商资质指引配置
-->
<template>
  <div class="h-full">
    <div class="h-full flex">
      <div class="h-full w-300px flex-shrink-0">
        <el-card class="h-full">
          <div class="mb-10px flex items-center text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">资质类型</span>
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
                <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="flex mb-10px">
            <el-input
              size="small"
              placeholder="请输入搜索内容"
              prefix-icon="el-icon-search"
              v-model="treeKeyword"
              class="mr-10px flex-1"
              clearable
              @keyup.enter.native="searchTreeData"
            ></el-input>
            <el-button type="primary" class="!h-36px" size="mini" @click="searchTreeData"
              >搜索</el-button
            >
          </div>
          <div class="tree overflow-y-auto">
            <el-tree
              v-if="treeStandBy"
              :default-expand-all="defaultExpandAll"
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :filter-node-method="filterTreeNode"
              :expand-on-click-node="false"
              :props="defaultTreeProps"
              node-key="id"
              ref="tree"
              :default-expanded-keys="defaultExpandIds"
              @node-expand="nodeExpand"
              @node-collapse="nodeCollapse"
            >
              <div slot-scope="{ node, data }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="flex-1 mr-15px truncate">
                    {{ node.label }}
                  </p>
                  <!-- <p :title="node.displayName" class="flex-1 mr-15px truncate">
                    {{ node.displayName }}
                  </p> -->
                  <div class="mr-5px">
                    <el-dropdown
                      v-if="
                        data.code === 'ContractorEntryGuide' ||
                          (!data.code && data.dicType === 'ContractorEntryGuide')
                      "
                    >
                      <span class="el-dropdown-link">
                        <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          :disabled="
                            !($hasAccess('createType') && data.code === 'ContractorEntryGuide')
                          "
                          @click.native="handleTreeData($event, 'createChild', data)"
                          >新增</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="
                            !(
                              $hasAccess('updateType') &&
                              !data.code &&
                              data.dicType === 'ContractorEntryGuide'
                            )
                          "
                          @click.native="
                            handleTreeData($event, data.parentId ? 'editChild' : 'edit', data)
                          "
                          >编辑</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="
                            !(
                              $hasAccess('deleteType') &&
                              !data.code &&
                              data.dicType === 'ContractorEntryGuide'
                            )
                          "
                          @click.native="removeTreeData($event, data)"
                          >删除</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </el-tree>
          </div>
        </el-card>
      </div>
      <div class="h-full rightCol flex-auto w-0px ml-10px">
        <el-card class="h-full" v-loading="loading">
          <div class="flex mb-20px">
            <el-input
              size="small"
              v-model="searchForm.name"
              clearable
              placeholder="标题名称"
              class="!w-50 !mr-10px"
            />
            <el-button type="primary" size="small" @click="searchList">搜索</el-button>
            <el-button size="small" @click="resetText">重置</el-button>
            <el-button
              :disabled="!$hasAccess('create')"
              type="primary"
              size="small"
              @click="openDeviceDialog('create')"
              >新增</el-button
            >
          </div>
          <el-table :data="tableData" height="calc(100% - 110px)" border stripe>
            <el-table-column
              type="index"
              label="序号"
              width="60"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="资质名称" prop="title" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="资质内容"
              prop="titleContent"
              min-width="200px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="资质类别"
              prop="directoryName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="上传示例" prop="fileId" show-overflow-tooltip>
              <template slot-scope="scope">
                <FormUpload :showText="true" v-model="scope.row.fileId"></FormUpload>
              </template>
            </el-table-column>
            <el-table-column
              label="上传时间"
              prop="creationTime"
              width="200px"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  :disabled="!$hasAccess('read')"
                  size="mini"
                  @click="openDeviceDialog('detail', scope.row)"
                  >查看</el-button
                >
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="openDeviceDialog('edit', scope.row)"
                  >编辑</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click="removeTableData(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="flex justify-end mt-20px">
            <el-pagination
              background
              @size-change="searchList"
              @current-change="findList"
              :current-page.sync="pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size.sync="pageSize"
              :total="total"
              :page-sizes="[15, 30, 45, 60, 75, 90]"
            >
            </el-pagination>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 树节点编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="treeDialogTitle"
      :visible.sync="treeDialog"
      width="718px"
      class="small-dialog"
      v-dialogDrag
      @open="dialogOpened"
    >
      <el-form :model="treeForm" :rules="treeRules" ref="treeForm" label-width="150px">
        <el-form-item label="上级目录" prop="lastName" v-if="lastName">
          <el-input
            disabled
            placeholder="请输入目录名称"
            :value="lastName"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="目录名称" prop="name">
          <el-input
            placeholder="请输入目录名称"
            v-model="treeForm.name"
            size="small"
            clearable
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="排序序号" prop="sortNum">
          <!-- v-if="treeHandleType === 'createChild' || treeHandleType === 'editChild'" -->
          <el-input
            placeholder="请输入排序序号"
            v-model.number="treeForm.sortNum"
            size="small"
            clearable
            maxlength="5"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveTreeForm"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="treeDialog = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 列表新增 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="deviceDialogTitle"
      :visible.sync="deviceDialog"
      width="718px"
      class="small-dialog"
      v-dialogDrag
      @open="dialogOpened"
    >
      <el-form
        v-if="deviceDialog"
        :model="aptitudeForm"
        :rules="aptitudeRules"
        ref="aptitudeForm"
        label-width="150px"
      >
        <el-form-item label="资质名称" prop="title">
          <el-input
            placeholder="请输入资质名称"
            v-model="aptitudeForm.title"
            size="small"
            clearable
            :disabled="tableFormDisabled"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="资质内容" prop="titleContent">
          <el-input
            placeholder="请输入资质内容"
            v-model="aptitudeForm.titleContent"
            size="small"
            clearable
            :disabled="tableFormDisabled"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="资质类别" prop="directoryName">
          <el-input
            placeholder="请输入资质类别"
            v-model="aptitudeForm.directoryName"
            size="small"
            clearable
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否必需" prop="isRequired">
          <el-radio-group v-model="aptitudeForm.isRequired" :disabled="tableFormDisabled">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="示例文件" prop="fileId" ref="formUpload">
          <FormUpload
            @change="fileIdChange"
            v-model="aptitudeForm.fileId"
            :disabled="tableFormDisabled"
          ></FormUpload>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer flex justify-center items-center"
        v-if="!tableFormDisabled"
      >
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveDeviceForm"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="deviceDialog = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import dayjs from 'dayjs'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import {
  GuidanceConfigurationDirectoryApi,
  GuidanceConfigurationApi,
} from '@wiz-api/contractor-management'
import FormUpload from '@/components/safety/FileUpload/FormUpload'

const dataCategoryApi = new DataCategoryApi()

const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()

const guidanceConfigurationDirectoryApi = new GuidanceConfigurationDirectoryApi()
const guidanceConfigurationApi = new GuidanceConfigurationApi()

export default {
  name: 'contractor-guideline-configuration',
  components: {
    FormUpload,
  },
  data() {
    const validateType = (rule, value, callback) => {
      if (this.aptitudeForm.type.length > 0) {
        callback()
      } else {
        callback(new Error('设备类别不能为空'))
      }
    }
    return {
      lastName: '',
      defaultExpandAll: false,
      treeStandBy: true, // 是否显目录树 用于刷新树
      searchForm: {
        name: '',
      },
      fileList: [],
      saveLoading: false,
      currentTreeSelect: {},
      pageNo: 1,
      pageSize: 15,
      total: 0,
      treeHandleType: '',
      treeForm: {},
      treeRules: {
        type: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
        unitId: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
        sortNum: [{ required: true, message: '必填', trigger: ['blur', 'change'] }],
      },
      typeList: [],
      treeDialog: false,
      treeDialogTitle: '',
      deviceDialogTitle: '',
      aptitudeRules: {
        // title: [{ required: true, validator: validateType, trigger: 'change' }],
        title: [{ required: true, message: '请输入资质名称', trigger: 'blur' }],
        titleContent: [{ required: true, message: '请输入资质内容', trigger: 'blur' }],
        directoryName: [{ required: true, message: '请选择资质类别', trigger: 'blur' }],
        isRequired: [{ required: true, message: '请选择是否必需', trigger: 'blur' }],
        fileId: [{ required: true, message: '请上传示例文件', trigger: ['blur', 'change'] }],
        creationTime: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      aptitudeForm: {},
      deviceDialog: false,
      deviceHandleType: '',
      showTypeDetail: false,
      treeKeyword: '',
      treeLoading: false,
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      // 原数据
      originTree: [],
      treeData: [],
      defaultExpandIds: [],
      keyword: '',
      tableData: [],
      loading: false,
      isDisabledIsLeaf: false,
      moduleAuth: null,
      pid: '',
      parenList: [],
    }
  },
  created() {
    this.getConfig()
    // this.getTreeData()
  },
  computed: {
    tableFormDisabled() {
      return this.deviceHandleType === 'detail'
    },
  },
  methods: {
    fileIdChange() {
      this.$refs.formUpload.$emit('el.form.change')
    },
    operateTree(bool) {
      this.defaultExpandIds = this.$options.data().defaultExpandIds
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    async getConfig() {
      const [err, abpConfigList] = await abpApplicationConfigurationApi.get()
      const [DiverListErr, res] = await dataCategoryApi.getByCode({
        code: abpConfigList.setting.values['ContractorManagement.DataCategory.ApplyGuide'],
      })
      if (!DiverListErr) {
        this.parenList = res.dataItems
        this.getTreeData()
      }
    },
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await guidanceConfigurationDirectoryApi.pagedListQuery({
        maxResultCount: 10000,
      })
      if (!err) {
        const map = res.items.reduce((pre, item) => {
          // this.defaultExpandIds.push(item.id)
          if (!pre[item.dicType]) {
            pre[item.dicType] = []
          }
          pre[item.dicType].push(item)
          return pre
        }, {})
        this.treeData = this.parenList.map((item) => {
          item.children = map[item.code] ? this.JSONToTree(map[item.code]) : []
          item.name = item.displayName
          return item
        })
        // 初始化选中第一资质类型
        // this.currentTreeSelect = this.treeData[0]?.children[0]
        // this.defaultExpandIds = [this.treeData[0].id]
        // this.$nextTick(() => {
        //   this.$refs.tree.setCurrentKey(this.treeData[0]?.children[0]?.id)
        // })
        this.findList()
      }
      this.treeLoading = false
    },
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    searchTreeData() {
      this.$refs.tree.filter(this.treeKeyword)
    },
    // 节点展开
    nodeExpand(data) {
      this.defaultExpandIds.push(data.id)
    },
    // 节点关闭
    nodeCollapse(data) {
      this.defaultExpandIds = _.difference(this.defaultExpandIds, [data.id])
    },
    handleDocNodeClick(data) {
      this.currentTreeSelect = data
      this.searchList()
    },
    async handleTreeData(e, type, data) {
      if (type === 'createChild') {
        this.lastName = data.name
      } else {
        this.lastName = this.treeData.find((item) => {
          return item.code === 'ContractorEntryGuide'
        })?.name
      }
      // this.lastName
      this.treeForm = this.$options.data().treeForm
      if (e && e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
      if (type !== 'create') {
        this.defaultExpandIds.push(data.id)
      }
      this.treeHandleType = type
      if (type === 'create' || type === 'createChild') {
        this.treeDialogTitle = '新增目录'
        this.treeForm.parentId = data.code ? null : data.id
        this.treeForm.dicType = data.code || data.dicType
      } else {
        this.treeForm = JSON.parse(JSON.stringify(data))
        this.treeDialogTitle = '编辑目录'
      }
      this.treeDialog = true
    },
    // 是否禁用子节点勾选
    dialogOpened() {
      if (this.treeDialog) {
        this.$nextTick(() => {
          this.$refs.treeForm.clearValidate()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.aptitudeForm.clearValidate()
        })
      }
    },
    async removeTreeData(e, data) {
      // 验证节点下面是否存在资质
      const [err, res] = await guidanceConfigurationApi.pagedListQuery({ directoryId: data.id })
      if (res.totalCount) {
        this.$message.warning({
          showClose: true,
          message: '当前节点存在资质',
        })
        return
      }

      if (e && e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
      if (!_.isEmpty(data.children)) {
        this.$message.warning({
          showClose: true,
          message: '此目录下关联着多个子目录，请删除全部子目录才能被删除！',
        })
        return
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [delErr, delRes] = await guidanceConfigurationDirectoryApi.callDelete(data.id)
          if (!delErr) {
            this.defaultExpandIds = _.difference(this.defaultExpandIds, [data.id])
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            this.getTreeData()
          } else {
            this.$message.error({
              showClose: true,
              message: delRes.msg,
            })
          }
        })
        .catch(() => {})
    },
    saveTreeForm() {
      this.$refs.treeForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          let nextErr = null
          let message = ''
          if (this.treeHandleType === 'create') {
            this.treeForm.parentId = null
          } else {
            this.treeForm.unitId = null
          }
          if (this.treeHandleType === 'create' || this.treeHandleType === 'createChild') {
            const [err, res] = await guidanceConfigurationDirectoryApi.create({
              body: { ...this.treeForm, isFixed: true },
            })
            nextErr = err
            message = '新增成功！'
          } else {
            const [err, res] = await guidanceConfigurationDirectoryApi.update(this.treeForm.id, {
              body: { ...this.treeForm, isFixed: true },
            })
            nextErr = err
            message = '编辑成功！'
          }
          if (!nextErr) {
            this.$message.success({
              showClose: true,
              message,
            })
            this.getTreeData()
            this.treeDialog = false
          }
          this.saveLoading = false
        }
      })
    },
    resetText() {
      this.searchForm.name = ''
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    // 数组转化成树结构
    JSONToTree(data, parent = null, pid = 'parentId') {
      const tree = []
      let temp = []
      // eslint-disable-next-line no-restricted-syntax
      for (const i of data) {
        if (i[pid] === parent) {
          const obj = i
          temp = this.JSONToTree(data, i.id, pid)
          if (temp.length > 0) {
            obj.children = temp
          }
          tree.push(obj)
        }
      }
      return tree
    },
    async findList() {
      this.loading = true
      const [err, res] = await guidanceConfigurationApi.pagedListQuery({
        directoryId: this.currentTreeSelect.id,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        title: this.searchForm.name,
      })
      if (!err) {
        res.items.forEach((item) => {
          item.creationTime = dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    async removeTableData(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await guidanceConfigurationApi.callDelete(data.id)
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            if (this.tableData.length === 1 && this.pageNo !== 1) {
              this.pageNo -= 1
            }
            this.findList()
          }
        })
        .catch(() => {})
    },
    async openDeviceDialog(type, data) {
      this.aptitudeForm = this.$options.data().aptitudeForm
      if (type === 'create') {
        if (
          !this.currentTreeSelect ||
          this.currentTreeSelect.code ||
          JSON.stringify(this.currentTreeSelect) === '{}'
        ) {
          this.$message.warning({
            showClose: true,
            message: '请选择目录树叶子节点！',
          })
          return
        }
        this.deviceDialogTitle = '新增'
      } else {
        this.aptitudeForm = JSON.parse(JSON.stringify(data))
        this.deviceDialogTitle = type === 'edit' ? '编辑' : '查看'
      }
      if (this.currentTreeSelect.name) {
        this.aptitudeForm.directoryName = this.currentTreeSelect.name
      }
      this.showTypeDetail = false
      this.deviceHandleType = type
      this.deviceDialog = true
    },
    saveDeviceForm() {
      this.$refs.aptitudeForm.validate(async (valid) => {
        if (valid) {
          // this.aptitudeForm.fileName = this.$refs.formUpload.fileList[0].name
          if (this.deviceHandleType === 'create') {
            this.createDevie()
          } else {
            this.updateDevice()
          }
        }
      })
    },
    async createDevie() {
      // 验证是否同名
      if (
        this.tableData.find((item) => {
          return item.title === this.aptitudeForm.title
        })
      ) {
        this.$message.warning({
          showClose: true,
          message: `已存在${this.aptitudeForm.title}`,
        })
        return
      }
      this.saveLoading = true
      const [err, res] = await guidanceConfigurationApi.create({
        body: {
          directoryId: this.currentTreeSelect.id,
          ...this.aptitudeForm,
        },
      })
      if (!err) {
        this.$message.success({
          showClose: true,
          message: '新增成功！',
        })
        this.findList()
        this.deviceDialog = false
      }
      this.saveLoading = false
    },
    async updateDevice() {
      this.saveLoading = true
      const [err, res] = await guidanceConfigurationApi.update(this.aptitudeForm.id, {
        body: {
          directoryId: this.currentTreeSelect.id,
          ...this.aptitudeForm,
        },
      })
      if (!err) {
        this.$message.success({
          showClose: true,
          message: '编辑成功！',
        })
        this.findList()
        this.deviceDialog = false
      }
      this.saveLoading = false
    },
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);

  ::v-deep .el-tree-node__content {
    height: 35px;

    .node-item {
      width: calc(100% - 24px);

      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}

.button-normal.el-button.el-tooltip {
  padding: 6px 12px !important;
  width: unset !important;
  height: unset !important;
}

::v-deep .el-select__tags .el-tag {
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

::v-deep .el-card__body {
  height: 100%;
}

.required-text--color {
  color: #ff3a30;
}

.down-file--color {
  color: #acdbff;
}
</style>
